import { render, staticRenderFns } from "./dataSetStatus.vue?vue&type=template&id=65880131&scoped=true&"
import script from "./dataSetStatus.vue?vue&type=script&lang=js&"
export * from "./dataSetStatus.vue?vue&type=script&lang=js&"
import style0 from "./dataSetStatus.vue?vue&type=style&index=0&id=65880131&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65880131",
  null
  
)

export default component.exports